import Style from "ol/style/Style";
import Circle from "ol/style/Circle";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import Text from "ol/style/Text";

export default function(marker){

    return new Style({
        image: new Circle({
            radius: 5,
            stroke: new Stroke(({
                color: '#000000'
            })),
            fill: new Fill({
                color: marker.color || '#000000'
            })
        }),
        text: marker.label ? new Text({
            font: '12px Source Sans Pro',
            fill: new Fill({ color: '#ffffff' }),
            backgroundFill: new Fill({ color: '#353535' }),
            padding: [3, 5, 3, 5],
            offsetY: -20,
            text: marker.label
        }) : null
    });
}
